export default __webpack_public_path__ + "static/media/rev_f_video_mobile.7b01f07a.mp4";